import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Tab, Box, Typography } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const BoxBanner = styled(Box)(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    max-width: 100%;
    display: none;
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 1.5rem;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        width: auto;
        display: flex;
        max-width: 14.5rem;
        padding-bottom: 0;
    }
`);

export const BoxCustom = styled(Box)(
    ({ theme }: ParamsStyle) => `
    .MuiTabs-indicator {
        height: 1.75rem;
        border-radius: 5px 5px 0px 0px;
        border-top: 2.6px solid #8D9BB5;
        border-right: 2.6px solid #8D9BB5;
        border-left: 2.6px solid #8D9BB5;
        border-bottom: 2.6px solid white;
        background-color: transparent;
    }

    .MuiTabs-flexContainer {
        height: 100%;
        gap: 2.75rem;
        align-items: flex-end;
        justify-content: flex-start;
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        .MuiTabs-flexContainer {
            gap: 2.3125rem;
        }

        .MuiTabs-indicator {
            height: 2.5625rem;
        }
    }
`);

export const TabCustom = styled(Tab)(
    ({ theme }: ParamsStyle) => `
        color: white;
        min-height: 0;
        font-weight: 600;
        font-size: .75rem;
        padding: .35rem .6rem .1rem;
        border-radius: 5px 5px 0px 0px;
        background: rgba(141, 155, 181, 0.5);
        transition: all 450ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

        &.Mui-selected {
            background: transparent;
            padding: .65rem .6rem .2rem;
            color: ${theme?.palette.primary.main};
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            width: 11.25rem;
            font-size: 1.25rem;
            padding: .35rem 1.2rem .1rem;

            &.Mui-selected {
                padding: .8rem 1.2rem .2rem;
            }
        }
`);

export const TypographyLight = styled(Typography)(
    ({ theme }: ParamsStyle) => `
        font-size: .9375rem;
        color: ${theme?.palette.primary.light};
        font-weight: 700;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            
        }
`);

export const BoxCase = styled(Box)(
    ({ theme }: ParamsStyle) => `
        display: flex;
        height: 2.625rem;
        align-items: center;
        justify-content: center;
        padding-top: 6px;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            
        }
`);

export const Label = styled(Box)(
    ({ theme }: ParamsStyle) => `
        width: 100%;

        .title {
            font-weight: 600;
            font-size: .75rem;
            color: ${theme?.palette.grey[400]};
        }

        .description {
            font-size: .9375rem;
            margin-top: .5rem;
            color: ${theme?.palette.primary.main};
        }

        label {
            display: flex;
        }

        svg {
            margin-left: 4px;
            height: .875rem;
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            
        }
`);

export const Ul = styled('ul')(
    ({ theme }: ParamsStyle) => `
        padding-left: 1.5rem;
        margin-bottom: 1.4375rem;

        li {
            text-align: start;
            padding-bottom: .2rem;
            list-style-type: disc;

            p {
                font-size: .875rem;
                line-height: 1rem;
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            
        }
`);

export const ProcedureCard = styled(Box)(
    ({ theme }: ParamsStyle) => `
        width: 100%;
        height: 2.5rem;
        display: flex;
        position: relative;
        align-items: center;
        border-radius: 1.5px;
        justify-content: center;
        transition: all 0.4s ease;

        svg {
            position: absolute;
            right: 0;
        }

        :hover {
            background: rgba(141, 155, 182, 0.15);
            svg {
                opacity: 1;
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            
        }
`);

export const BoxSvg = styled('div')(
    ({ theme }: ParamsStyle) => `
        svg {
            transition: all 0.4s ease;
        }

        &.show {
            svg {
                transform: rotate(180deg);
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            
        }
`);

export const GridTab = styled(Box)(
    ({ theme }: ParamsStyle) => `
    display: grid;    
    grid-template-columns: 50% 43% 7%;

    p {
        font-size: .75rem;
        line-height: 1rem;
        color: ${theme?.palette.grey[400]};
    }

    h6 {
        font-size: .875rem;
        line-height: 1.2;
        font-weight: 600;
        align-items: flex-end;
        color: ${theme?.palette.primary.main};
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        
    }
`);

export const BannerContent = styled.div(`
    width: 100%;
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin-top: .8rem;

    img {
        width: 100%;
        height: auto;
        max-width: 100%;
        border-radius: 20px;
        background-size: cover;
    }

    button {
        width: 117px;
        height: 30px;
        font-size: .75rem;
        padding: 0;
        position: absolute;
    }

    a {
        position: absolute;
        width: 120px;
        height: 40px;
        cursor: pointer;

        &.apple {
            bottom: 84px;
        }

        &.android {
            bottom: 28px;
        }
    }
`);

